/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDisplayNameStatusClient} from '../api'

 export const useQueryGetDisplayNameStatusClient = createReactQueryHook('getDisplayNameStatusClient', getDisplayNameStatusClient)
